import { render, staticRenderFns } from "./SimpleImageComponent.vue?vue&type=template&id=132f12ac&"
import script from "./SimpleImageComponent.vue?vue&type=script&lang=js&"
export * from "./SimpleImageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports